import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { DataOrigin } from "../../model/DataOrigin";
import { UserRegistrationDataMobileService } from "./user-registration-data-mobile.service";
import { UserRegistrationMockService } from "./user-registration-data-mock.service";
import { UserRegistrationDataService } from "./user-registration-data.service";

@Injectable({
  providedIn: "root",
})
export abstract class UserRegistrationFactoryService {
  private services = new Map<DataOrigin, UserRegistrationDataService>();

  constructor(
    private handlerService: HandlerService
  ) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): UserRegistrationDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new UserRegistrationDataMobileService(
          this.handlerService
        );
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new UserRegistrationMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new UserRegistrationMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
